import get from 'lodash/get'

export const getRoute = ({ routes, routeKey }) => {
	if(typeof routeKey === 'string' || (typeof routeKey === 'object' && Array.isArray(routeKey))) {
		const pathStr = (typeof(routeKey) === 'string' ? routeKey.split('.') : routeKey).join('.children.');
		const route = get(routes, pathStr);
		if(route) {
			return route ? { ...route, key: routeKey } : route;
		}
		else {
			console.warn('Route not found for getRoute function: ', routeKey);
			return route;
		}
	}
	else {
		console.warn('Invalid route path for getRoute function: ', routeKey);
		return undefined;
	}
}